import { render, staticRenderFns } from "./ProposalNew.vue?vue&type=template&id=15c49a0e&"
import script from "./ProposalNew.vue?vue&type=script&lang=js&"
export * from "./ProposalNew.vue?vue&type=script&lang=js&"
import style0 from "./ProposalNew.vue?vue&type=style&index=0&id=15c49a0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports